import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { formatAmount, toastError, toastSuccess } from "../../../../../utils/constants";
import {
  getHostAndHostessDetails_action,
  insertUpdateHostAndHostess_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/hostAndHostess_action/hostAndHostess_action";
import $ from "jquery";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

// Calculate number of days in a date range (inclusive)
function calcDays(dateFrom, dateTo) {
  if (!dateFrom || !dateTo) return 0;
  const diff = moment(dateTo).diff(moment(dateFrom), "days") + 1;
  return diff > 0 ? diff : 0;
}

const emptyRow = () => ({ dateFrom: null, dateTo: null, days: 0, quantity: "" });

class HostHostessRequirements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: "", buttonName: "", action: "" },
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Remark: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      is_View: false,
      StatusID: "",
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      exhDetails: {},
      bankDetails: [],
      // Rates from master
      HostRate: 0,
      HostessRate: 0,
      currency: "INR",
      // GST
      CGST: 0,
      SGST: 0,
      IGST: 0,
      // Table rows
      hostRows: [emptyRow()],
      hostessRows: [emptyRow()],
    };
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  handleConfirmation(flag) {
    const { confirmationObj } = this.state;
    if (flag && confirmationObj.action === 0) {
      this.addHostAndHostess();
    }
    this.setState({ isOpenConfirmationModal: false });
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state?.Deadline
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID: this.props.location.state?.StatusID || "",
      is_View:
        this.props.location.state?.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    this.getHostAndHostessDetails();
    $(document).ready(function () { $(this).scrollTop(0); });
  }

  getHostAndHostessDetails() {
    this.setState({ isLoading: true });
    this.props
      .getHostAndHostessDetails_action()
      .then((data) => {
        if (data.error != 1) {
          const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
          const isINR = loginData.CountryID == 91;
          const currency = isINR ? "INR" : "USD";

          const rateRow = data.rates && data.rates.length > 0 ? data.rates[0] : {};
          const HostRate = isINR ? (rateRow.HostRateINR || 0) : (rateRow.HostRateUSD || 0);
          const HostessRate = isINR ? (rateRow.HostessRateINR || 0) : (rateRow.HostessRateUSD || 0);

          // gstRates = actual % values (0.09, 0.18) from Service table
          // gstFlags = which ones apply (0 or 1) from sp_Check_GST_ManualForm
          const gstRates = data.gstRates && data.gstRates.length > 0 ? data.gstRates[0] : {};
          const gstFlags = data.gstFlags && data.gstFlags.length > 0 ? data.gstFlags[0] : {};

          this.setState({
            currency,
            HostRate,
            HostessRate,
            CGST: gstFlags.CGST === 1 ? (gstRates.CGST || 0) : 0,
            SGST: gstFlags.SGST === 1 ? (gstRates.SGST || 0) : 0,
            IGST: gstFlags.IGST === 1 ? (gstRates.IGST || 0) : 0,
            exhDetails: data.exhDetails && data.exhDetails.length > 0 ? data.exhDetails[0] : {},
            bankDetails: data.bankDetails || [],
          });

          if (data.hdrData && data.hdrData.length > 0) {
            this.setState({
              Remark: data.hdrData[0].Remark || "",
              Is_Agree: data.hdrData[0].Is_Agree || false,
            });
          }

          if (data.dtlData && data.dtlData.length > 0) {
            const hostRows = data.dtlData
              .filter((r) => r.HostType === 1)
              .map((r) => ({
                dateFrom: r.DateFrom ? new Date(r.DateFrom) : null,
                dateTo: r.DateTo ? new Date(r.DateTo) : null,
                days: r.Days || 0,
                quantity: r.Quantity != null ? String(r.Quantity) : "",
              }));
            const hostessRows = data.dtlData
              .filter((r) => r.HostType === 2)
              .map((r) => ({
                dateFrom: r.DateFrom ? new Date(r.DateFrom) : null,
                dateTo: r.DateTo ? new Date(r.DateTo) : null,
                days: r.Days || 0,
                quantity: r.Quantity != null ? String(r.Quantity) : "",
              }));
            this.setState({
              hostRows: hostRows.length > 0 ? hostRows : [emptyRow()],
              hostessRows: hostessRows.length > 0 ? hostessRows : [emptyRow()],
            });
          }

          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  handleDateChange(type, index, dates) {
    const [start, end] = dates;
    const rows = type === "host" ? [...this.state.hostRows] : [...this.state.hostessRows];
    rows[index] = {
      ...rows[index],
      dateFrom: start,
      dateTo: end,
      days: calcDays(start, end),
    };
    type === "host"
      ? this.setState({ hostRows: rows })
      : this.setState({ hostessRows: rows });
  }

  handleQuantityChange(type, index, value) {
    const rows = type === "host" ? [...this.state.hostRows] : [...this.state.hostessRows];
    rows[index] = { ...rows[index], quantity: value };
    type === "host"
      ? this.setState({ hostRows: rows })
      : this.setState({ hostessRows: rows });
  }

  addRow(type) {
    if (type === "host") {
      this.setState({ hostRows: [...this.state.hostRows, emptyRow()] });
    } else {
      this.setState({ hostessRows: [...this.state.hostessRows, emptyRow()] });
    }
  }

  removeRow(type, index) {
    const rows = type === "host" ? [...this.state.hostRows] : [...this.state.hostessRows];
    if (rows.length === 1) return;
    rows.splice(index, 1);
    type === "host"
      ? this.setState({ hostRows: rows })
      : this.setState({ hostessRows: rows });
  }

  calcRowAmount(rate, row) {
    const qty = parseFloat(row.quantity) || 0;
    return rate * qty * (row.days || 0);
  }

  calcTableAmount(rate, rows) {
    return rows.reduce((sum, r) => sum + this.calcRowAmount(rate, r), 0);
  }

  buildDtlList() {
    const { hostRows, hostessRows, HostRate, HostessRate } = this.state;
    const list = [];
    const isValidRow = (r) => r.dateFrom && r.dateTo && r.quantity !== "" && parseFloat(r.quantity) > 0;
    hostRows.filter(isValidRow).forEach((r) => {
      list.push({
        HostType: 1,
        DateFrom: r.dateFrom,
        DateTo: r.dateTo,
        Days: r.days,
        Quantity: parseFloat(r.quantity),
        Rate: HostRate,
        Amount: this.calcRowAmount(HostRate, r),
      });
    });
    hostessRows.filter(isValidRow).forEach((r) => {
      list.push({
        HostType: 2,
        DateFrom: r.dateFrom,
        DateTo: r.dateTo,
        Days: r.days,
        Quantity: parseFloat(r.quantity),
        Rate: HostessRate,
        Amount: this.calcRowAmount(HostessRate, r),
      });
    });
    return list;
  }

  validateRows(rows, label) {
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const hasDate = r.dateFrom && r.dateTo;
      const hasQty = r.quantity !== "" && r.quantity !== null && parseFloat(r.quantity) > 0;
      const isEmpty = !hasDate && !hasQty;
      if (isEmpty) continue; // fully empty row — will be filtered out
      if (hasQty && !hasDate) {
        toastError(`Please select a date range for ${label} row ${i + 1}`);
        return false;
      }
      if (hasDate && !hasQty) {
        toastError(`Please enter quantity for ${label} row ${i + 1}`);
        return false;
      }
    }
    return true;
  }

  inputValidate() {
    const { Is_Agree, hostRows, hostessRows } = this.state;
    if (!this.validateRows(hostRows, "Host")) return false;
    if (!this.validateRows(hostessRows, "Hostess")) return false;

    const isValidRow = (r) => r.dateFrom && r.dateTo && r.quantity !== "" && parseFloat(r.quantity) > 0;
    const hasHost = hostRows.some(isValidRow);
    const hasHostess = hostessRows.some(isValidRow);
    if (!hasHost && !hasHostess) {
      toastError("Please fill at least one Host or Hostess requirement");
      return false;
    }

    if (!Is_Agree) {
      this.setState({ Is_AgreeErr: "Kindly agree the above disclaimer for Hoste & Hostess Services Provider" });
      return false;
    }
    return true;
  }

  addHostAndHostess() {
    const { Remark, Is_Agree, StatusID } = this.state;
    if (!this.inputValidate()) return;
    this.setState({ isLoading: true });
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    const list = this.buildDtlList();

    this.props
      .insertUpdateHostAndHostess_action(Remark, Is_Agree, list, ManualFormsID, ServiceID, VendorDetails)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess(
            StatusID == 0
              ? "Host and Hostess Form Submitted Successfully"
              : "Host and Hostess Form Updated Successfully"
          );
          setTimeout(() => {
            this.props.navigate("/manualForms");
          }, 2000);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  renderTable(type, rate, rows, label, isDisabled) {
    const { currency } = this.state;
    const currencyLabel = currency === "INR" ? "INR" : "USD";

    const tableAmount = this.calcTableAmount(rate, rows);
    const { CGST, SGST, IGST } = this.state;

    const cgstAmt = CGST > 0 ? tableAmount * CGST : 0;
    const sgstAmt = SGST > 0 ? tableAmount * SGST : 0;
    const igstAmt = IGST > 0 ? tableAmount * IGST : 0;
    const totalAmt = tableAmount + cgstAmt + sgstAmt + igstAmt;

    return (
      <div className="table-responsive mt-3">
        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
          <thead>
            <tr>
              <th style={{ width: "25%" }}>Date</th>
              <th style={{ width: "25%" }}>
                Per Day {label} Charges {currencyLabel}{" "}
                <span style={{ color: "#d32f2f", fontWeight: "bold" }}>
                  {formatAmount(rate)}/- (A)
                </span>
              </th>
              <th style={{ width: "15%" }}>Days (B)</th>
              <th style={{ width: "20%" }}>Amount C *(A×B)</th>
              {!isDisabled && <th style={{ width: "5%" }}></th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const rowAmt = this.calcRowAmount(rate, row);
              return (
                <tr key={i}>
                  <td>
                    <DatePicker
                      selectsRange
                      startDate={row.dateFrom}
                      endDate={row.dateTo}
                      onChange={(dates) => this.handleDateChange(type, i, dates)}
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Select date range"
                      className="form-control"
                      disabled={isDisabled}
                      isClearable={!isDisabled}
                      popperPlacement="auto"
                      popperProps={{ strategy: "fixed" }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      min={0}
                      value={row.quantity}
                      placeholder="Qty"
                      disabled={isDisabled}
                      onChange={(e) => this.handleQuantityChange(type, i, e.target.value)}
                    />
                  </td>
                  <td className="text-center align-middle">
                    {row.days}
                  </td>
                  <td className="text-end align-middle">
                    {formatAmount(rowAmt)}
                  </td>
                  {!isDisabled && (
                    <td className="text-center align-middle">
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm border-0"
                        onClick={() => this.removeRow(type, i)}
                        disabled={rows.length === 1}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
            {/* Summary rows */}
            <tr>
              <td colSpan={!isDisabled ? 3 : 3} className="text-end"><strong>Amount</strong></td>
              <td className="text-end">{formatAmount(tableAmount)}</td>
              {!isDisabled && <td></td>}
            </tr>
            {CGST > 0 && (
              <tr>
                <td colSpan={!isDisabled ? 3 : 3} className="text-end">CGST @ {(CGST * 100).toFixed(0)}%</td>
                <td className="text-end">{formatAmount(cgstAmt)}</td>
                {!isDisabled && <td></td>}
              </tr>
            )}
            {SGST > 0 && (
              <tr>
                <td colSpan={!isDisabled ? 3 : 3} className="text-end">SGST @ {(SGST * 100).toFixed(0)}%</td>
                <td className="text-end">{formatAmount(sgstAmt)}</td>
                {!isDisabled && <td></td>}
              </tr>
            )}
            {IGST > 0 && (
              <tr>
                <td colSpan={!isDisabled ? 3 : 3} className="text-end">IGST @ {(IGST * 100).toFixed(0)}%</td>
                <td className="text-end">{formatAmount(igstAmt)}</td>
                {!isDisabled && <td></td>}
              </tr>
            )}
            <tr>
              <td colSpan={!isDisabled ? 3 : 3} className="text-end"><strong>Total Amount</strong></td>
              <td className="text-end"><strong>{formatAmount(totalAmt)}</strong></td>
              {!isDisabled && <td></td>}
            </tr>
          </tbody>
        </table>
        {!isDisabled && (
          <div className="text-end mt-1">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => this.addRow(type)}
            >
              + Add Row
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Is_AgreeErr,
      DeadlineDate,
      StatusID,
      is_View,
      isHideSection,
      isOpenConfirmationModal,
      exhDetails,
      bankDetails,
      hostRows,
      hostessRows,
      HostRate,
      HostessRate,
    } = this.state;

    const currentDate = moment().format("DD-MM-YYYY");
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    const isDisabled = isDeadlinePassed || is_View;

    return (
      <>
        {isOpenConfirmationModal ? (
          <ConfirmationModal
            onConfirmation={this.handleConfirmation}
            message={this.state.confirmationObj}
          />
        ) : null}
        {isLoading ? <Loader /> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? "with-dr-container" : ""}>
          <div className="">
            {!isHideSection && (
              <div className="row">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="exb-top-space">
              <div className="row">
                <div className="card rounded-0 pt-1 shadow-none">
                  <div className="card-header p-2">
                    <h3 className="card-title" style={{ fontSize: "15px" }}>
                      Host Hostess Requirement
                    </h3>
                  </div>
                  <div className="card-body p-1 m-2">

                    {!isHideSection && (
                      <>
                        <strong><p className="m-0">Exhibitor Details:</p></strong>
                        <div className="table-responsive mb-3">
                          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "30%" }}><strong>Exhibiting Company Name:</strong></td>
                                <td>{exhDetails.ExhibitorCompanyName || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Booth No.:</strong></td>
                                <td>{exhDetails.StallName || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Hall No.:</strong></td>
                                <td>{exhDetails.HallName || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Contact Person:</strong></td>
                                <td>{exhDetails.ContactPerson || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Designation:</strong></td>
                                <td>{exhDetails.Designation || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Mobile:</strong></td>
                                <td>{exhDetails.Mobile || "-"}</td>
                              </tr>
                              <tr>
                                <td><strong>Email ID:</strong></td>
                                <td>{exhDetails.PrimaryEmail || "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* Agency Contact Details — cards */}
                        {console.log("bankDetails----->",bankDetails)}
                        {bankDetails && bankDetails.length > 0 && (
                          <>
                            <strong><p className="m-0 mb-1">Contact Details:</p></strong>
                            <div style={{ display: "flex", flexWrap: "wrap", marginBottom: 14 }}>
                              {bankDetails.map((data, i) => (
                                <div key={i} className="table-responsive w-50" style={{ backgroundColor: "#ebebeb", marginBottom: 14, borderRight: "1px solid lightgray" }}>
                                  <div style={{ margin: "10px 0 10px 10px", lineHeight: "23px" }}>
                                    {data.Name && <p className="m-0"><strong>Name:</strong> {data.Name}</p>}
                                    {data.Address && <p className="m-0"><strong>Address:</strong> {data.Address}</p>}
                                    {data.Phone && <p className="m-0"><strong>Phone:</strong> {data.Phone}</p>}
                                    {data.Mobile && <p className="m-0"><strong>Mobile:</strong> {data.Mobile}</p>}
                                    {data.Fax && <p className="m-0"><strong>Fax:</strong> {data.Fax}</p>}
                                    {data.PrimaryEmail && <p className="m-0"><strong>Email:</strong> {data.PrimaryEmail}</p>}
                                    {data.SecondaryEmail && <p className="m-0"><strong>Email (Secondary):</strong> {data.SecondaryEmail}</p>}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        <div className="row mt-2">
                          <h6 className="mt-2">
                            Host & Hostess Requirements{" "}
                            <span className="text-danger">
                              Last Date Of Submission -{" "}
                              {this.props.location?.state?.ActualDeadline
                                ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                                : "-"}
                            </span>
                          </h6>
                        </div>
                      </>
                    )}

                    {/* Host Table */}
                    <p className="mb-1 mt-3"><strong>Host Requirement</strong></p>
                    {this.renderTable("host", HostRate, hostRows, "Host", isDisabled)}

                    {/* Hostess Table */}
                    <p className="mb-1 mt-4"><strong>Hostess Requirement</strong></p>
                    {this.renderTable("hostess", HostessRate, hostessRows, "Hostess", isDisabled)}

                    {/* Bank Details — shown to exhibitor only */}
                    {!isHideSection && bankDetails && bankDetails.length > 0 && (
                      <div className="mt-4">
                        {bankDetails.map((bank, idx) => (
                          <div key={idx} className="table-responsive mb-3">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                              <thead>
                                <tr><th colSpan={2}><strong>Bank Details {bankDetails.length > 1 ? `(${idx + 1})` : ""}</strong></th></tr>
                              </thead>
                              <tbody>
                                {bank.BankName && <tr><td style={{ width: "30%" }}>Bank Name</td><td>{bank.BankName}</td></tr>}
                                {bank.BeneficiaryName && <tr><td>Beneficiary Name</td><td>{bank.BeneficiaryName}</td></tr>}
                                {bank.BeneficiaryAddress && <tr><td>Beneficiary Address</td><td>{bank.BeneficiaryAddress}</td></tr>}
                                {bank.AccountNumber && <tr><td>Account No.</td><td>{bank.AccountNumber}</td></tr>}
                                {bank.SwiftCode && <tr><td>Swift Code</td><td>{bank.SwiftCode} (Abroad transfer)</td></tr>}
                                {bank.IFSCCode && <tr><td>IFSC Code</td><td>{bank.IFSCCode} (Within Country transfer)</td></tr>}
                                {bank.PAN && <tr><td>PAN No.</td><td>{bank.PAN}</td></tr>}
                                {bank.GST && <tr><td>GST No.</td><td>{bank.GST}</td></tr>}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    )}

                    {!isHideSection && (
                      <>
                        <div style={{ marginTop: "14px", textAlign: "left" }}>
                          <strong><p className="m-0 mb-2">Please Note:</p></strong>
                          <ul style={{ listStyleType: "disc", paddingLeft: "20px", lineHeight: "25px" }}>
                            <li>RATES MENTIONED ABOVE ARE ON HIRE BASIS AND APPLICABLE FOR SHOW DAYS ONLY.</li>
                            <li>Exhibitors are responsible for arranging badges for the hired host and hostess.</li>
                            <li>Orders are valid only when accompanied with full payment before the deadline.</li>
                            <li>Please make payment online through net banking and No Cash Accepted.</li>
                          </ul>
                        </div>
                        <div className="terms-container" style={{ textAlign: "left" }}>
                          <h3 style={{ fontSize: "16px", marginBottom: "8px" }}>Terms and Conditions:</h3>
                          <ol style={{ paddingLeft: "20px", margin: 0 }}>
                            <li>The minimum period of employment is average 8 hrs / day. 30 minutes lunch time excluded.</li>
                            <li>The assigned staff will report directly to the exhibitor's booth on-site. On the first show day, staff will be present at least 1 hr before the show opens.</li>
                            <li>Temporary staff should not be entrusted with handling of cash or other valuable items.</li>
                            <li>Exhibitors will be responsible for the safety of the temporary staff (host / hostess) while on duty on their booth.</li>
                          </ol>
                        </div>
                        <div className="terms-container" style={{ textAlign: "left" }}>
                          <p style={{ margin: 0, paddingTop: "8px", color: "#333", fontWeight: 600 }}>
                            Temporary staff will be properly dressed in formals i.e. Males will be wearing formal and females wearing saris or business suits who will help the exhibitors promote their products / services to their customers / buyers. They will not extend any help to clean tables / wash utensils etc. They will also not take the responsibility of serving alcohol.
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                  <div className="row m-1">
                    <form>
                      <strong><label>Additional Note:</label></strong>
                      <textarea
                        className="form-control"
                        value={Remark}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        maxLength={300}
                        disabled={isDisabled}
                        rows="3"
                      />
                      <label className="d-flex mt-1">
                        <input
                          type="checkbox"
                          checked={Is_Agree}
                          disabled={isDisabled}
                          onChange={(e) => this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: "" })}
                        />
                        <strong>
                          {" "}I confirm the above requirements and disclaimer
                          <span className="required">*</span>.
                        </strong>
                      </label>
                      <span className="text-danger d-block mt-1">{Is_AgreeErr}</span>
                    </form>
                  </div>
              </div>

              {!isHideSection && isDeadlinePassed && (
                <div className="row">
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                </div>
              )}

              {!isHideSection && (
                <div className="d-flex gap-1 justify-content-end mt-0">
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    style={{ marginRight: 10 }}
                    disabled={isDisabled}
                    onClick={() =>
                      this.setState({
                        isOpenConfirmationModal: true,
                        confirmationObj: { message: "Do you want to Submit?", buttonName: "Submit", action: 0 },
                      })
                    }
                  >
                    Submit
                  </button>
                  <button
                    className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                    onClick={() => this.props.navigate("/manualForms")}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, { getHostAndHostessDetails_action, insertUpdateHostAndHostess_action })(
    HostHostessRequirements
  )
);
